import { CategoryV2 } from '@occ/api-client';

type Props = {
  q: string;
  categoryPath: string;
  size?: number;
  page?: number;
  code?: string;
  sort?: string;
};

export const getCategory = async ({ q, categoryPath, size = 30, page = 0, sort }: Props) => {
  const api = new CategoryV2({ baseUrl: '' });
  const result = await api.getCategoryV2({ p: categoryPath, q, page, size, sort });
  return result.data;
};
